export class Status {
  static ACTIVE = "active";
  static COMINGSOON = "comingSoon";
  static HIDDEN = "hidden";
  static MAINTENANCE = "maintenance";
  static CANCELLED = "cancelled";
  static COMPLETED = "completed";

  static StatusList = [
    { key: Status.ACTIVE, value: "Active" },
    { key: Status.COMINGSOON, value: "Coming Soon" },
    { key: Status.HIDDEN, value: "Hidden" },
    { key: Status.MAINTENANCE, value: "Under Maintenance" },
    { key: Status.CANCELLED, value: "Cancelled" },
    { key: Status.COMPLETED, value: "Completed" },
  ];

  static getStatusValue = (key) => {
    return (
      Status.StatusList.find((item) => item.key === key)?.value ??
      "Status Not Found"
    );
  };

  static getReservationStatusList = () => [
    { value: Status.ACTIVE, label: Status.getStatusValue(Status.ACTIVE) },
    { value: Status.COMPLETED, label: Status.getStatusValue(Status.COMPLETED) },
    { value: Status.CANCELLED, label: Status.getStatusValue(Status.CANCELLED) },
  ];
}
